<app-navbar [title]="'Zadania'">
	<button (click)="addOpen()" class="btn btn-primary"><i class="fas fa-plus"></i> Dodaj</button>
</app-navbar>

<div
	class="modal fade"
	id="taskAddModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="taskAddModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title">Nowe zadanie</h5>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<app-php-task-add
					[types]="parameters.tasksTypes"
					[users]="parameters.users"
					objType="task"
					objId="[auto]"
					(added)="addDone()"
				></app-php-task-add>
			</div>
		</div>
	</div>
</div>

<app-php-tasks-list-filters
	userFilters="tasks"
	[statuses]="parameters.statuses"
	[types]="parameters.tasksTypes"
	[objTypes]="parameters.tasksObjTypes"
	(selected)="filtersSelected($event)"
></app-php-tasks-list-filters>

<app-dynamic-table
	module="task"
	[elements]="data"
	[tableRows]="tableRows"
	(filtersClicked)="filtersOpen()"
></app-dynamic-table>
